module finadai.app.findYourCredit {
    export var NAME = 'finadai.app.findYourCredit';

    function FindYourCreditController($scope, customersService: services.CustomersService, $mdDialog, $filter) {
        return ;
        $scope.formData = {};
        $scope.message = null;
        $scope.customer_number = 0;
        $scope.userData = null;
        $scope.loading = false;
        $scope.otorgantes = [];
        customersService.proxyGetOriginator().then(response => {
            const otorgantes = response.data.Data.Originadores;
            otorgantes.forEach(o => {
                $scope.otorgantes.push({id: o.Originador, name: o.OriginadorNombre});
            });
        });
        $scope.submit = (form) => {
            if (form.$valid) {
                $scope.loading = true;
                $scope.formData.originator_id = $scope.formData.originator.id;
                customersService.proxySearch($scope.formData).then(response => {
                    $scope.loading = false;
                    if (angular.isArray(response.data.Data.Saldo)) {
                        const saldos = <models.proxy.Saldo[]>response.data.Data.Saldo;
                        let message = `<h4 class="search_saldo">Saldo total: ${$filter('currency')(parseFloat(saldos[0].SaldoTotal))}</h4><br /><br />`;
                        saldos.forEach(s => {
                            message += `<p> Tipo de producto: ${s.TipoProducto} <br/>
                          Numero Tarjeta de Credito/Credito: ${s.CreditoId} <br />
                          Originador: ${s.OriginadorNombre} <br />
                          Fecha de apertura: ${$filter('momentDate')(s.FechaApertura)} <br />
                          *Monto Dispuesto: ${$filter('currency')(parseFloat(s.MontoSolicitado))}<br /><br />
                          Saldo Total: ${$filter('currency')(parseFloat(s.SaldoTotal))} <br /><br />
                          <br /><br /><br />
                          *Saldo de Castigo a la Fecha de Adquisición</p>`
                            $scope.customer_number = s.NumCliente;
                        })
                        $scope.message = {
                            type: 'success',
                            text: message,
                            title: `Amigo, el detalle de tus créditos es:`,
                            stub: 'Para conocer los detalles de tus créditos y realizar un acuerdo para liquidar tu deuda, es necesario crear una cuenta'
                        }
                    } else {
                        const saldo = <models.proxy.Saldo>response.data.Data.Saldo;
                        $scope.message = {
                            type: 'success',
                            text: ` <p>Tipo de producto: ${saldo.TipoProducto} <br/>
                       Numero Tarjeta de Credito/Credito: ${saldo.CreditoId} <br />
                       Originador: ${saldo.OriginadorNombre} <br />
                       Fecha de apertura: ${$filter('momentDate')(saldo.FechaApertura)} <br />
                      *Monto Dispuesto: ${$filter('currency')(parseFloat(saldo.MontoSolicitado))} <br />
                       Saldo Total: ${$filter('currency')(parseFloat(saldo.SaldoTotal))} <br />
                       <br /><br /><br />
                       *Saldo de Castigo a la Fecha de Adquisición</p>`,
                            title: `Amigo, el detalle de tu crédito es:`,
                            stub: 'Para conocer el detalle de tu crédito y realizar un acuerdo para liquidar tu deuda, es necesario crear una cuenta'
                        }
                        $scope.customer_number = saldo.NumCliente;
                    }
                }).catch(rejection => {
                    $scope.loading = false;
                    if (rejection.data.data && rejection.data.data.DetailedException) {
                        $scope.message = {type: 'danger', text: rejection.data.data.DetailedException};
                    } else {
                        $scope.message = {
                            type: 'danger',
                            title: "No hemos encontrado detalle de algún crédito con la información que has proporcionado. Comunícate a través del chat para que podamos asesorarte."
                        };
                    }
                })
            }
        }

        $scope.showTerms = (ev) => {
            $mdDialog.show({
                templateUrl: 'app/layout/terms.tpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false // Only for -xs, -sm breakpoints.
            });
        }
    }

    export function run() {
        var findYourCredit = angular.module(NAME, []);
        findYourCredit.controller('FindYourCreditController', FindYourCreditController)
    }
}
finadai.app.findYourCredit.run();
